// const createSelectors = (_store) => {
//   const store = _store;
//   store.use = {};
//   const state = store.getState();
//   for (const k of Object.keys(state)) {
//     store.use[k] = () => store((s) => s[k]);
//   }
//   return store;
// };
// export { createSelectors };
import { shallow } from "zustand/shallow";

/**
 * Wraps a zustand store so destructuring only subscribes
 * to the keys actually used, avoiding re-renders on others.
 *
 * @param {Function} store - The zustand store created by create()
 * @returns {Function} - The wrapped store hook
 */
function withSelectors(store) {
  return (selector) => {
    if (typeof selector === "function") {
      // Regular selector usage
      return store(selector, shallow);
    }

    // No selector passed — return proxy with individually subscribed keys
    const state = store.getState();
    const result = {};

    for (const key of Object.keys(state)) {
      Object.defineProperty(result, key, {
        enumerable: true,
        get: () => store((s) => s[key]),
      });
    }

    return result;
  };
}

export { withSelectors };
